import React, { useEffect, useState, useContext, useCallback  } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS, API_BASE_URL_DOCS,API_BASE_DOCS } from "../../../config/api";
import "bootstrap/dist/css/bootstrap.min.css";
import Select from "react-select";

/* ===============================
   CARD REUTILIZABLE
================================ */
const Card = ({ title, children }) => (
  <div className="card h-100 shadow-sm">
    <div className="card-header bg-light fw-semibold">{title}</div>
    <div className="card-body">{children}</div>
  </div>
);

const MyCurriculum = () => {
  const { authFetch } = useContext(AuthContext);

  const [formData, setFormData] = useState({});
  const [curriculumId, setCurriculumId] = useState(null); // 🔥 CLAVE
  const [activeTab, setActiveTab] = useState("personal");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

    // DEPARTAMENTOS Y MUNICIPIOS
    const [departments, setDepartments] = useState([]);
  
    const [birthDepartment, setBirthDepartment] = useState("");
    const [birthMunicipalities, setBirthMunicipalities] = useState([]);
    const [birthMunicipio, setBirthMunicipio] = useState("");
  
    const [resDepartment, setResDepartment] = useState("");
    const [resMunicipalities, setResMunicipalities] = useState([]);
    const [resMunicipio, setResMunicipio] = useState("");
  
  
    // REFERENCIAS LABORALES
    const [workReferences, setWorkReferences] = useState([]);
    const [showWorkModal, setShowWorkModal] = useState(false);
    const [newWorkRef, setNewWorkRef] = useState({});
  
    // DOCUMENTOS DE EDUCACIÓN
    const [studies, setStudies] = useState([]);
    const [showStudyModal, setShowStudyModal] = useState(false);
    const [newStudy, setNewStudy] = useState({});

    // ESTADOS DE DOCUMENTOS
    const [documents, setDocuments] = useState([]);
    const [showDocumentModal, setShowDocumentModal] = useState(false);
    const [newDocumentType, setNewDocumentType] = useState("");
    const [newDocumentFile, setNewDocumentFile] = useState(null);
    const [docError, setDocError] = useState("");    

     // UNIVERSIDADES DESDE BACKEND
    const [universities, setUniversities] = useState([]);
  
    const fetchWorkReferences = useCallback(async () => {
      if (!curriculumId) return;

      try {
        const res = await authFetch(ENDPOINTS.getReferences(curriculumId));
        setWorkReferences(res.data || []);
      } catch (err) {
        console.error(err);
      }
    }, [authFetch, curriculumId]);

    const fetchStudies = useCallback(async () => {
      if (!curriculumId) return;

      try {
        const res = await authFetch(ENDPOINTS.getEducation(curriculumId));
        setStudies(res.data || []);
      } catch (err) {
        console.error(err);
      }
    }, [authFetch, curriculumId]);

    const fetchDocuments = useCallback(async () => {
      if (!curriculumId) return;

      try {
        const res = await authFetch(
          `${ENDPOINTS.getDocsCurriculum}?Id=${curriculumId}`
        );

        if (res.success) {
          setDocuments(res.documents || []);
        } else {
          setDocuments([]);
        }
      } catch (error) {
        console.error("Error cargando documentos:", error);
        setDocuments([]);
      }
    }, [authFetch, curriculumId]);

  /* ===============================
     CARGAR MI HOJA DE VIDA
  ================================ */
  useEffect(() => {
    const fetchMyCurriculum = async () => {
      try {
        const res = await authFetch(ENDPOINTS.getMyCurriculum());

        if (!res.success) {
          setError(res.message || "No se pudo cargar la hoja de vida");
          return;
        }

        setFormData(res.data);
        setCurriculumId(res.data.Id); // 🔥 ID REAL DEL CURRICULUM
      } catch (err) {
        console.error(err);
        setError("Error al cargar la hoja de vida");
      } finally {
        setLoading(false);
      }
    };

    fetchMyCurriculum();
  }, [authFetch]);

  /* ===============================
     HANDLE CHANGE
  ================================ */
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  /* ===============================
     CARGAR REFERENCIAS LABORALES
  ================================ */
  useEffect(() => {
    if (activeTab === "work") {
      fetchWorkReferences();
    }
  }, [activeTab, fetchWorkReferences]);

  /* ===============================
   CARGAR ESTUDIOS
  ================================ */
  useEffect(() => {
    if (activeTab === "studies") {
      fetchStudies();
    }
  }, [activeTab, fetchStudies]);

  /* ===============================
    CARGAR DOCUMENTOS
  ================================ */
  useEffect(() => {
    if (activeTab === "documents") {
      fetchDocuments();
    }
  }, [activeTab, fetchDocuments]);

// 1️⃣ Cargar departamentos (solo una vez)
useEffect(() => {
  const fetchDepartments = async () => {
    try {
      const res = await authFetch(ENDPOINTS.getDepartment);
      setDepartments(res.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  fetchDepartments();
}, [authFetch]);


// 2️⃣ Convertir NOMBRE → ID del departamento (cuando ya existen departments)
useEffect(() => {
  if (!formData.birth_department || departments.length === 0) return;

  const dep = departments.find(
    d => d.nombre === formData.birth_department
  );

  if (dep) {
    setBirthDepartment(String(dep.id_departamento)); // 🔥 CLAVE
  }
}, [formData.birth_department, departments]);

// 3️⃣ Cargar municipios cuando cambia el departamento (ID)
useEffect(() => {
  if (!birthDepartment) return;

  const fetchMunicipios = async () => {
    try {
      const res = await authFetch(
        ENDPOINTS.getMunicipios(birthDepartment)
      );
      setBirthMunicipalities(res.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  fetchMunicipios();
}, [birthDepartment, authFetch]);


// 4️⃣ 🔥 ESTE useEffect VA AQUÍ (el que preguntaste)
useEffect(() => {
  if (!formData.birth_municipality || birthMunicipalities.length === 0) return;

  const mun = birthMunicipalities.find(
    m => m.nombre === formData.birth_municipality
  );

  if (mun) {
    setBirthMunicipio(String(mun.id_municipio)); // 🔥 CLAVE
  }
}, [birthMunicipalities, formData.birth_municipality]);

// INICIALIZAR DEPARTAMENTO DE RESIDENCIA
useEffect(() => {
  if (!formData.residence_department || departments.length === 0) return;

  const dep = departments.find(
    d => d.nombre === formData.residence_department
  );

  if (dep) {
    setResDepartment(String(dep.id_departamento));
  }
}, [formData.residence_department, departments]);

// CARGAR MINUCIPIOS DE RESIDENCIA
useEffect(() => {
  if (!resDepartment) return;

  const fetchMunicipios = async () => {
    try {
      const res = await authFetch(
        ENDPOINTS.getMunicipios(resDepartment)
      );
      setResMunicipalities(res.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  fetchMunicipios();
}, [resDepartment, authFetch]);

// INICIALIZAR MUNICIPIO DE RESIDENCIA NOMBRE
useEffect(() => {
  if (!formData.residence_municipality || resMunicipalities.length === 0) return;

  const mun = resMunicipalities.find(
    m => m.nombre === formData.residence_municipality
  );

  if (mun) {
    setResMunicipio(mun.id_municipio);
  }
}, [resMunicipalities, formData.residence_municipality]);


  /* ===============================
     GUARDAR CAMBIOS
  ================================ */
const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");
  setSuccess("");

  if (!curriculumId) {
    setError("No se pudo identificar la hoja de vida");
    return;
  }

  try {
    const formDataToSend = new FormData();

    // 🔑 ID obligatorio
    formDataToSend.append("Id", curriculumId);

    // 🔁 Enviar todos los campos
    Object.entries(formData).forEach(([key, value]) => {
      if (value === null || value === undefined) return;

      // ❌ NO reenviar la ruta vieja de la foto
      if (key === "document_photo" && typeof value === "string") return;

      formDataToSend.append(key, value);
    });

    const res = await fetch(ENDPOINTS.updateCurriculum(curriculumId), {
      method: "POST", // 🔥 IGUAL QUE updateCurriculum
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        // ❌ NO pongas Content-Type
      },
      body: formDataToSend,
    });

    const data = await res.json();

    if (!data.success) {
      setError(data.message || "Error al actualizar la hoja de vida");
      return;
    }

    setSuccess("Hoja de vida actualizada correctamente ✔");

  } catch (error) {
    console.error(error);
    setError("Error de conexión con el servidor");
  }
};



   /* ===============================
       SUBIR DOCUMENTOS
    ================================ */
    const handleSaveDocument = async () => {
    setDocError("");
  
    if (!newDocumentType || !newDocumentFile) {
      setDocError("Seleccione tipo y archivo");
      return;
    }
  
    try {
      const formData = new FormData();
      formData.append("Id", curriculumId); // 👈 IMPORTANTE
      formData.append("tipo_documento", newDocumentType);
      formData.append("archivo", newDocumentFile);
  
      const res = await fetch(ENDPOINTS.createDocsCurriculum, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: formData,
      });
  
      const data = await res.json();
  
      if (!data.success) {
        setDocError(data.message || "Error al subir documento");
        return;
      }
  
      setShowDocumentModal(false);
      setNewDocumentType("");
      setNewDocumentFile(null);
      fetchDocuments(); // 🔁 refresca tabla
    } catch (error) {
      console.error(error);
      setDocError("Error de servidor");
    }
  };
  
    /* ===============================
       ELIMINAR DOCUMENTOS
    ================================ */
  const handleDeleteDocument = async (doc) => {
    const confirmDelete = window.confirm(
      "¿Estás seguro de que deseas eliminar este documento?\n\nEsta acción no se puede deshacer."
    );
  
    if (!confirmDelete) return;
  
    try {
      const res = await authFetch(ENDPOINTS.deleteDocCurriculum, {
        method: "DELETE",
        body: JSON.stringify({
          Id: curriculumId,
          filename: doc.name, 
        }),
      });
  
      if (!res.success) {
        alert(res.message || "No se pudo eliminar el documento");
        return;
      }
  
      // 🔁 refrescar lista
      fetchDocuments();
  
    } catch (error) {
      console.error(error);
      alert("Error al eliminar el documento");
    }
  };

  const handleDownloadCV = () => {
  if (!curriculumId) {
    alert("No se pudo identificar la hoja de vida");
    return;
  }

  const url = `${ENDPOINTS.curriculumcertificate}?id_curriculum=${curriculumId}`;
  window.open(url, "_blank");
};

// INPUT O SELECT
const nivelesConUniversidad = [
  "Técnico",
  "Tecnólogo",
  "Profesional",
  "Maestría",
  "Doctorados",
  "Especialización",
];

useEffect(() => {
  const fetchUniversities = async () => {
    try {
      const res = await authFetch(ENDPOINTS.getUniversities);

      if (res.success) {
        setUniversities(res.data || []);
      } else {
        setUniversities([]);
      }
    } catch (error) {
      console.error("Error cargando universidades:", error);
      setUniversities([]);
    }
  };

  fetchUniversities();
}, [authFetch]);


const universityOptions = universities.map((uni) => ({
  value: uni.name, // lo que se guarda
  label: uni.name, // lo que se muestra
}));  

  /* ===============================
     RENDER
  ================================ */
  if (loading) {
    return (
      <div className="text-center mt-5">
        Cargando hoja de vida...
      </div>
    );
  }

  return (
    <div className="container-fluid p-4">
      <div className="d-flex justify-content-between align-items-center my-3">
        <h3>MI HOJA DE VIDA</h3>
        <button
          type="button"
          className="btn btn-outline-pink"
          onClick={handleDownloadCV}
        >
          <i className="bi bi-download me-1"></i> Descargar
        </button>

      </div>

      <form className="card p-4 shadow-sm" onSubmit={handleSubmit}>

        {/* ALERTAS */}
        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        {/* ================= TABS ================= */}
        <ul className="nav nav-tabs mb-4">
          {[
            { key: "personal", label: "Datos personales" },
            { key: "work", label: "Experiencia laboral" },
            { key: "studies", label: "Estudios" },
            { key: "documents", label: "Documentos" },
          ].map((tab) => (
            <li className="nav-item" key={tab.key}>
              <button
                type="button"
                className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>

        {/* ================= DATOS PERSONALES ================= */}
        {activeTab === "personal" && (
          <>
            <div className="row g-4">

                {/* DATOS IDENTIFICACIÓN */}
                <div className="col-md-6">
                  <Card title="Datos de identificación">
                    <div className="mb-3">
                      <label className="form-label">Tipo de documento</label>
                      <select
                        name="type_doc"
                        className="form-select"
                        value={formData.type_doc || ""}
                        onChange={handleChange}
                        disabled
                      >
                        <option value="">Seleccione</option>
                        <option value="CC">Cédula de ciudadanía</option>
                        <option value="CE">Cédula de extranjería</option>
                        <option value="TI">Tarjeta de identidad</option>
                      </select>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Documento</label>
                      <input
                        className="form-control"
                        value={formData.document || ""}
                        disabled
                      />
                    </div>
                  </Card>
                </div>


                <div className="col-md-6">
                  <Card title="Foto del documento">
                    <div className="mb-3">
                      <label className="form-label">Subir foto</label>
                      <input
                        type="file"
                        name="document_photo"
                        className="form-control"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setFormData(prev => ({
                              ...prev,
                              document_photo: file // 👈 archivo real
                            }));
                          }
                        }}
                      />
                    </div>

                  {/* FOTO ACTUAL DESDE BD */}
                  {formData.document_photo && typeof formData.document_photo === "string" && (
                    <img
                      src={`${API_BASE_URL_DOCS}${formData.document_photo}`}
                      alt="Foto actual"
                      style={{ width: "150px", borderRadius: "8px", marginBottom: "10px" }}
                    />
                  )}

                  </Card>
                </div>

                {/* DATOS NACIMIENTO */}
                <div className="col-md-6">
                  <Card title="Datos de nacimiento">
                    <div className="mb-3">
                      <label className="form-label">Fecha de nacimiento</label>
                      <input
                        type="date"
                        name="birthdate"
                        className="form-control"
                        value={formData.birthdate || ""}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Departamento de nacimiento</label>
                      <select
                        className="form-select"
                        value={birthDepartment} // ID
                       onChange={(e) => {
                        const depId = e.target.value;
                        const depName = departments.find(
                          d => String(d.id_departamento) === depId
                        )?.nombre || "";

                        setBirthDepartment(depId);

                        setFormData(prev => ({
                          ...prev,
                          birth_department: depName,
                          birth_municipality: ""
                        }));
                      }}
                      >
                        <option value=""hidden>Seleccione departamento</option>
                        {departments.map(dep => (
                          <option key={dep.id_departamento} value={dep.id_departamento}>
                            {dep.nombre}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Municipio de nacimiento</label>
                      <select
                        className="form-select"
                        value={birthMunicipio} // ID
                        disabled={!birthDepartment}
                        onChange={(e) => {
                          const munId = e.target.value;
                          const munName = birthMunicipalities.find(
                            m => String(m.id_municipio) === munId
                          )?.nombre || "";

                          setBirthMunicipio(munId);

                          setFormData(prev => ({
                            ...prev,
                            birth_municipality: munName
                          }));
                        }}

                      >
                        <option value=""hidden>Seleccione municipio</option>
                        {birthMunicipalities.map(mun => (
                          <option key={mun.id_municipio} value={mun.id_municipio}>
                            {mun.nombre}
                          </option>
                        ))}
                      </select>
                    </div>


                  </Card>
                </div>

            {/* IDENTIDAD */}
            <div className="col-md-6">
              <Card title="Identidad">
                <div className="mb-3">
                  <label>Primer nombre</label>
                  <input
                    name="first_name"
                    className="form-control"
                    value={formData.first_name || ""}
                    onChange={handleChange}
                    disabled
                  />
                </div>

                <div className="mb-3">
                  <label>Segundo nombre</label>
                  <input
                    name="second_name"
                    className="form-control"
                    value={formData.second_name || ""}
                    onChange={handleChange}
                     disabled
                  />
                </div>

                <div className="mb-3">
                  <label>Primer apellido</label>
                  <input
                    name="last_name"
                    className="form-control"
                    value={formData.last_name || ""}
                    onChange={handleChange}
                     disabled
                  />
                </div>

                <div className="mb-3">
                  <label>Segundo apellido</label>
                  <input
                    name="second_last_name"
                    className="form-control"
                    value={formData.second_last_name || ""}
                    onChange={handleChange}
                     disabled
                  />
                </div>
              </Card>
            </div>

            {/* ESTADO */}
            <div className="col-md-6">
              <Card title="Estado">

                <div className="mb-3">
                  <label>RH</label>
                  <input
                    name="RH"
                    className="form-control"
                    value={formData.RH || ""}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <label>Género</label>
                  <select
                    name="gender"
                    className="form-select"
                    value={formData.gender || ""}
                    onChange={handleChange}
                  >
                    <option value="">Seleccione</option>
                    <option value="F">Femenino</option>
                    <option value="M">Masculino</option>
                    <option value="Otro">Otro</option>
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Libreta militar</label>

                  <div className="d-flex gap-4 mt-1">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="military_notebook"
                        value="Si"
                        checked={formData.military_notebook === "Si"}
                        onChange={handleChange}
                      />
                      <label className="form-check-label">Sí</label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="military_notebook"
                        value="No"
                        checked={formData.military_notebook === "No"}
                        onChange={handleChange}
                      />
                      <label className="form-check-label">No</label>
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Perfil profesional</label>
                  <textarea
                    name="profile"
                    className="form-control"
                    rows="4"
                    value={formData.profile || ""}
                    onChange={handleChange}
                    placeholder="Describe brevemente el perfil profesional"
                  />
                </div>
              </Card>
            </div>

            <div className="col-md-6">
              <Card title="Contacto">
                
                <div className="mb-3">
                  <label>Correo electrónico</label>
                  <input
                    name="email"
                    className="form-control"
                    value={formData.email || ""}
                    onChange={handleChange}
                  />
                </div>
                
                <div className="mb-3">
                  <label>Celular</label>
                  <input
                    name="number_phone"
                    className="form-control"
                    value={formData.number_phone || ""}
                    onChange={handleChange}
                  />
                </div>

              </Card>
            </div>

            <div className="col-md-6">
              <Card title="Contacto de emergencia">
                
                <div className="mb-3">
                  <label>Nombre</label>
                  <input
                    name="emergency_name"
                    className="form-control"
                    value={formData.emergency_name || ""}
                    onChange={handleChange}
                  /> 
                </div>
                
                <div className="mb-3">
                  <label>Número de celular</label>
                  <input
                    name="emergency_number"
                    className="form-control"
                    value={formData.emergency_number || ""}
                    onChange={handleChange}
                  />
                </div>
                
                <div className="mb-3">
                  <label>Parentesco</label>
                  <input
                    name="relationship_emergency"
                    className="form-control"
                    value={formData.relationship_emergency || ""}
                    onChange={handleChange}
                  />
                </div>

              </Card>
            </div>

            <div className="col-md-6">
              <Card title="Domicilio">
      
                <div className="mb-3">
                  <label className="form-label">Departamento de residencia</label>
                  <select
                    className="form-select"
                    value={resDepartment}
                    onChange={(e) => {
                      setResDepartment(e.target.value);
                      setFormData(prev => ({
                        ...prev,
                        residence_department: e.target.selectedOptions[0].text
                      }));
                    }}
                  >
                    <option value=""hidden>Seleccione departamento</option>
                    {departments.map(dep => (
                      <option key={dep.id_departamento} value={dep.id_departamento}>
                        {dep.nombre}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Municipio de residencia</label>
                  <select
                    className="form-select"
                    value={resMunicipio}
                    disabled={!resDepartment}
                    onChange={(e) => {
                      setResMunicipio(e.target.value);
                      setFormData(prev => ({
                        ...prev,
                        residence_municipality: e.target.selectedOptions[0].text
                      }));
                    }}
                  >
                    <option value=""hidden>Seleccione municipio</option>
                    {resMunicipalities.map(mun => (
                      <option key={mun.id_municipio} value={mun.id_municipio}>
                        {mun.nombre}
                      </option>
                    ))}
                  </select>
                </div>
         
                
                <div className="mb-3">
                  <label>Barrio</label>
                  <input
                    name="neighborhood"
                    className="form-control"
                    value={formData.neighborhood || ""}
                    onChange={handleChange}
                  />
                </div>
                
                <div className="mb-3">
                  <label>Dirección</label>
                  <input
                    name="address"
                    className="form-control"
                    value={formData.address || ""}
                    onChange={handleChange}
                  />
                </div>

              </Card>
            </div>

            <div className="col-md-6">
              <Card title="Medidas">
                
                <div className="mb-3">
                  <label>Talla de camisa (S, M, L, XL)</label>
                  <input
                    name="shirt_size"
                    className="form-control"
                    value={formData.shirt_size || ""}
                    onChange={handleChange}
                  />
                </div>
                
                <div className="mb-3">
                  <label>Talla de pantalon</label>
                  <input
                    name="pants_size"
                    className="form-control"
                    value={formData.pants_size || ""}
                    onChange={handleChange}
                  />
                </div>
                
                <div className="mb-3">
                  <label>Talla de calzado</label>
                  <input
                    name="shoe_size"
                    className="form-control"
                    value={formData.shoe_size || ""}
                    onChange={handleChange}
                  />
                </div>

              </Card>
            </div>

            <div className="col-md-6">
              <Card title="Entidades de salud">
                
                <div className="mb-3">
                  <label>Eps</label>
                  <select
                    name="name_eps"
                    className="form-select"
                    value={formData.name_eps || ""}
                    onChange={handleChange}
                  >
                    <option value=""hidden>Seleccione</option>
                    <option value="COOSALUD">COOSALUD</option>
                    <option value="NUEVA EPS">NUEVA EPS</option>
                    <option value="MUTUAL SER">MUTUAL SER</option>
                    <option value="ALIANSALUD">ALIANSALUD</option>
                    <option value="SALUD TOTAL">SALUD TOTAL</option>
                    <option value="SANITAS">SANITAS</option>
                    <option value="SURA">SURA</option>
                    <option value="FAMISANAR">FAMISANAR</option>
                    <option value="SERVICIO OCCIDENTAL DE SALUD">SERVICIO OCCIDENTAL DE SALUD</option>
                    <option value="SALUD MIA">SALUD MIA</option>
                    <option value="COMFENALCO VALLE">COMFENALCO VALLE</option>
                    <option value="COMPENSAR">COMPENSAR</option>
                    <option value="EPM">EPM</option>
                    <option value="CAJACOPI ATLANTICO">CAJACOPI ATLANTICO</option>
                    <option value="CAPRESOCA">CAPRESOCA</option>
                    <option value="COMFACHOCO">COMFACHOCO</option>
                    <option value="COMFAORIENTE">COMFAORIENTE</option>
                    <option value="EPS FAMILIAR DE COLOMBIA">EPS FAMILIAR DE COLOMBIA</option>
                    <option value="ASMET SALUD">ASMET SALUD</option>
                    <option value="EMSSANAR E.S.S.">EMSSANAR E.S.S.</option>
                    <option value="CAPITAL SALUD">CAPITAL SALUD</option>
                    <option value="SAVIA SALUD">SAVIA SALUD</option>
                    <option value="DUSAKAWI EPSI">DUSAKAWI EPSI</option>
                    <option value="ASOCIACION INDIGENA DEL CAUCA EPSI">ASOCIACION INDIGENA DEL CAUCA EPSI</option>
                    <option value="ANAS WAYUU EPSI">ANAS WAYUU EPSI</option>
                    <option value="MALLASMAS EPSI">MALLASMAS EPSI</option>
                    <option value="PIJAOS SALUD EPSI">PIJAOS SALUD EPSI</option>
                    <option value="SALUD BOLIVAR EPS SAS">SALUD BOLIVAR EPS SAS</option>
                  </select>
                </div>
                
                <div className="mb-3">
                  <label>Pensión</label>
                  <select
                    name="name_pension"
                    className="form-select"
                    value={formData.name_pension || ""}
                    onChange={handleChange}
                  >
                    <option value=""hidden>Seleccione</option>
                    <option value="PORVENIR">PORVENIR</option>
                    <option value="COLPENSIONES">COLPENSIONES</option>
                    <option value="PROTECCIÓN">PROTECCIÓN</option>
                    <option value="SKANDIA(OLD MUTAL)">SKANDIA(OLD MUTAL)</option>
                  </select>
                </div>
                
                <div className="mb-3">
                  <label>Cesantía</label>
                  <select
                    name="name_cesantia"
                    className="form-select"
                    value={formData.name_cesantia || ""}
                    onChange={handleChange}
                  >
                    <option value=""hidden>Seleccione</option>
                    <option value="PORVENIR">PORVENIR</option>
                    <option value="COLPENSIONES">COLPENSIONES</option>
                    <option value="PROTECCIÓN">PROTECCIÓN</option>
                    <option value="SKANDIA(OLD MUTAL)">SKANDIA(OLD MUTAL)</option>
                  </select>
                </div>

              </Card>
            </div>

            <div className="col-md-6">
              <Card title="Referencia familiar">
                  
                <div className="mb-3">
                  <label>Nombre referencia</label>
                  <input
                    name="name_personal_reference"
                    className="form-control"
                    value={formData.name_personal_reference || ""}
                    onChange={handleChange}
                  />
                </div>
                  
                <div className="mb-3">
                  <label>Celular</label>
                  <input
                    name="phone_personal_reference"
                    className="form-control"
                    value={formData.phone_personal_reference || ""}
                    onChange={handleChange}
                  />
                </div>
                  
                <div className="mb-3">
                  <label>Parentesco</label>
                  <input
                    name="relationship_personal_reference"
                    className="form-control"
                    value={formData.relationship_personal_reference	 || ""}
                    onChange={handleChange}
                  />
                </div>
                  
                <div className="mb-3">
                  <label>Ocupación</label>
                  <input
                    name="occupation_personal_reference"
                    className="form-control"
                    value={formData.occupation_personal_reference	 || ""}
                    onChange={handleChange}
                  />
                </div>

              </Card>
            </div>
            </div>

            {/* BOTÓN SOLO PARA ESTA PESTAÑA */}
            <div className="text-end mt-4">
              <button type="submit" className="btn btn-outline-pink">
                Guardar cambios
              </button>
            </div>
          </>
        )}

        {/* ================= REFERENCIAS LABORALES ================= */}
        {activeTab === "work" && (
          <Card title="Experiencias laborales">
            <div className="d-flex justify-content-end mb-3">
              <button
                type="button"
                className="btn btn-outline-purple"
                onClick={() => setShowWorkModal(true)}
              >
                + Agregar experiencia
              </button>
            </div>

            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Empresa</th>
                    <th>Cargo</th>
                    <th>Jefe inmediato</th>
                    <th>Celular</th>
                    <th>Experiencia</th>
                    <th>Duración</th>
                    <th>Motivo retiro</th>
                    <th>Certificado</th>
                  </tr>
                </thead>
            <tbody>
              {workReferences.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center text-muted">
                    No hay experiencias laborales registradas
                  </td>
                </tr>
              ) : (
                workReferences.map((ref) => (
                  <tr key={ref.Id}>
                    <td>{ref.name_company}</td>
                    <td>{ref.position}</td>
                    <td>{ref.immediate_boss}</td>
                    <td>{ref.phone_boss}</td>
                    <td>{ref.experience}</td>
                    <td>{ref.time_company}</td>
                    <td>{ref.reason_retiro}</td>
                    <td>
                      {ref.labor_certificate ? (
                        <a
                          className="btn btn-outline-purple btn-sm me-2"
                          href={`${API_BASE_URL_DOCS}${ref.labor_certificate}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                      <i className="bi bi-eye-fill me-1"></i> Ver PDF
                        </a>
                      ) : (
                        "—"
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>

              </table>
            </div>
          </Card>
        )}

        {/* ================= ESTUDIOS ================= */}
        {activeTab === "studies" && (
          <Card title="Estudios">
            <div className="d-flex justify-content-end mb-3">
              <button
                type="button"
                className="btn btn-outline-purple"
                onClick={() => setShowStudyModal(true)}
              >
                + Agregar
              </button>
            </div>

            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Nivel académico</th>
                    <th>Institución</th>
                    <th>Titulación</th>
                    <th>Fecha finalización</th>
                    <th>Documento</th>
                  </tr>
                </thead>
                <tbody>
                  {studies.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center text-muted">
                        No hay estudios registrados
                      </td>
                    </tr>
                  ) : (
                    studies.map((edu) => (
                      <tr key={edu.Id}>
                        <td>{edu.academic_level}</td>
                        <td>{edu.name_institution}</td>
                        <td>{edu.name_titulation}</td>
                        <td>{edu.date_end?.split(" ")[0]}</td>
                        <td>
                          {edu.document ? (
                            <a
                              className="btn btn-outline-purple btn-sm"
                              href={`${API_BASE_URL_DOCS}${edu.document}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className="bi bi-eye-fill me-1"></i> Ver PDF
                            </a>
                          ) : (
                            "—"
                          )}
                        </td>

                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </Card>
        )}

        {/* ================= DOCUMENTOS ================= */}
        {activeTab === "documents" && (
          <Card title="Documentos">
            <div className="d-flex justify-content-end mb-3">
              <button
                type="button"
                className="btn btn-outline-purple"
                onClick={() => setShowDocumentModal(true)}
              >
                + Agregar
              </button>
            </div>

            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Documento</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {documents.length === 0 ? (
                    <tr>
                      <td colSpan="2" className="text-center text-muted">
                        No hay documentos cargados
                      </td>
                    </tr>
                  ) : (
                    documents.map((doc, index) => (
                      <tr key={index}>
                        <td>{doc.name}</td>
                        <td className="d-flex gap-2">
                          <a
                            className="btn btn-outline-purple btn-sm"
                            href={`${API_BASE_DOCS}${doc.url}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="bi bi-eye-fill me-1"></i> Ver
                          </a>

                          <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => handleDeleteDocument(doc)}
                          >
                            <i className="bi bi-trash-fill me-1"></i>
                          </button>
                        </td>

                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </Card>
        )}

      </form>

      {/* ================= MODAL REFERENCIAS ================= */}
      {showWorkModal && (
        <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,.5)" }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Agregar experiencia laboral</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowWorkModal(false)}
                />
              </div>

              <div className="modal-body">
                <div className="row g-3">

                  <div className="col-md-6">
                    <label>Empresa</label>
                    <input
                      className="form-control"
                      onChange={(e) =>
                        setNewWorkRef({ ...newWorkRef, name_company: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-md-6">
                    <label>Cargo</label>
                    <input
                      className="form-control"
                      onChange={(e) =>
                        setNewWorkRef({ ...newWorkRef, position: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-md-6">
                    <label>Jefe inmediato</label>
                    <input
                      className="form-control"
                      onChange={(e) =>
                        setNewWorkRef({ ...newWorkRef, immediate_boss: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-md-6">
                    <label>Teléfono</label>
                    <input
                      className="form-control"
                      onChange={(e) =>
                        setNewWorkRef({ ...newWorkRef, phone_boss: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-md-6">
                    <label>Experiencia</label>
                    <input
                      className="form-control"
                      onChange={(e) =>
                        setNewWorkRef({ ...newWorkRef, experience: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-md-6">
                    <label>Duración</label>
                    <input
                      className="form-control"
                      placeholder="Ej: 1 año"
                      onChange={(e) =>
                        setNewWorkRef({ ...newWorkRef, time_company: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-md-6">
                    <label>Motivo retiro</label>
                    <input
                      className="form-control"
                      onChange={(e) =>
                        setNewWorkRef({ ...newWorkRef, reason_retiro: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-md-12">
                    <label>Certificado laboral</label>
                    <input
                      type="file"
                      className="form-control"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={(e) =>
                        setNewWorkRef({
                          ...newWorkRef,
                          labor_certificate: e.target.files[0],
                        })
                      }
                    />
                  </div>

                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowWorkModal(false)}
                >
                  Cancelar
                </button>

            <button
              className="btn btn-outline-pink"
              onClick={async () => {
                try {
                  const formData = new FormData();

                  // 🔴 NOMBRE EXACTO COMO EN PHP
                  formData.append("Id_curriculum", curriculumId);
                  formData.append("name_company", newWorkRef.name_company);
                  formData.append("position", newWorkRef.position);
                  formData.append("experience", newWorkRef.experience);
                  formData.append("time_company", newWorkRef.time_company);
                  formData.append("immediate_boss", newWorkRef.immediate_boss);
                  formData.append("phone_boss", newWorkRef.phone_boss);
                  formData.append("reason_retiro", newWorkRef.reason_retiro);

                  if (newWorkRef.labor_certificate) {
                    formData.append(
                      "labor_certificate",
                      newWorkRef.labor_certificate
                    );
                  }

                  const res = await fetch(ENDPOINTS.createReference, {
                    method: "POST",
                    headers: {
                      // ⚠️ NUNCA pongas Content-Type aquí
                      Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                    body: formData,
                  });

                  const data = await res.json();

                  if (!data.success) {
                    alert(data.message);
                    return;
                  }

                  setShowWorkModal(false);
                  setNewWorkRef({});
                  await fetchWorkReferences(); 

                } catch (error) {
                  console.error(error);
                }
              }}
            >
              Guardar
            </button>

              </div>
            </div>
          </div>
        </div>
      )}

      {showStudyModal && (
      <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,.5)" }}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Agregar estudio</h5>
              <button
                className="btn-close"
                onClick={() => setShowStudyModal(false)}
              />
            </div>

            <div className="modal-body">
              <div className="row g-3">

                <div className="col-md-6">
                  <label>Nivel académico</label>
                  <select
                    className="form-select"
                    onChange={(e) =>
                      setNewStudy({ ...newStudy, academic_level: e.target.value })
                    }
                  >
                    <option value=""hidden>Seleccione</option>
                    <option value="Bachiller">Bachiller</option>
                    <option value="Curso">Curso</option>
                    <option value="Técnico">Técnico</option>
                    <option value="Tecnólogo">Tecnólogo</option>
                    <option value="Profesional">Profesional</option>
                    <option value="Maestría">Maestría</option>
                    <option value="Doctorados">Doctorados</option>
                    <option value="Especialización">Especialización</option>
                  </select>
                </div>

             <div className="col-md-6">
                  <label>Institución</label>

                  {nivelesConUniversidad.includes(newStudy.academic_level) ? (
                    // 🔽 SELECT DE UNIVERSIDADES
                    <Select
                      options={universityOptions}
                      placeholder="Buscar universidad..."
                      isClearable
                      value={
                        universityOptions.find(
                          (opt) => opt.value === newStudy.name_institution
                        ) || null
                      }
                      onChange={(selected) =>
                        setNewStudy({
                          ...newStudy,
                          name_institution: selected ? selected.value : ""
                        })
                      }
                    />

                  ) : (
                    // ✍️ INPUT LIBRE
                    <input
                      className="form-control"
                      placeholder="Digite el nombre de la institución"
                      value={newStudy.name_institution || ""}
                      onChange={(e) =>
                        setNewStudy({
                          ...newStudy,
                          name_institution: e.target.value
                        })
                      }
                    />
                  )}
                </div>

                <div className="col-md-6">
                  <label>Titulación</label>
                  <input
                    className="form-control"
                    onChange={(e) =>
                      setNewStudy({ ...newStudy, name_titulation: e.target.value })
                    }
                  />
                </div>

                <div className="col-md-6">
                  <label>Fecha finalización</label>
                  <input
                    type="date"
                    className="form-control"
                    onChange={(e) =>
                      setNewStudy({ ...newStudy, date_end: e.target.value })
                    }
                  />
                </div>

                <div className="col-md-12">
                  <label>Documento</label>
                  <input
                    type="file"
                    className="form-control"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={(e) =>
                      setNewStudy({
                        ...newStudy,
                        document: e.target.files[0],
                      })
                    }
                  />
                </div>

              </div>
            </div>

            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => setShowStudyModal(false)}
              >
                Cancelar
              </button>

              <button
                className="btn btn-outline-pink"
                onClick={async () => {
                  try {
                    const formData = new FormData();

                    formData.append("Id_curriculum", curriculumId);
                    formData.append("academic_level", newStudy.academic_level);
                    formData.append("name_institution", newStudy.name_institution);
                    formData.append("name_titulation", newStudy.name_titulation);
                    formData.append("date_end", newStudy.date_end);

                    if (newStudy.document) {
                      formData.append("document", newStudy.document);
                    }

                    const res = await fetch(ENDPOINTS.createEducation, {
                      method: "POST",
                      headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                      },
                      body: formData,
                    });

                    const data = await res.json();

                    if (!data.success) {
                      alert(data.message);
                      return;
                    }

                    setShowStudyModal(false);
                    setNewStudy({});
                    await fetchStudies();

                  } catch (error) {
                    console.error(error);
                  }
                }}
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>
      )}
      
      {/* ================= MODAL DOCUMENTOS ================= */}
      {showDocumentModal && (
      <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,.5)" }}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Agregar documento</h5>
              <button
                className="btn-close"
                onClick={() => setShowDocumentModal(false)}
              />
            </div>

            <div className="modal-body">
              {docError && (
                <div className="alert alert-danger">{docError}</div>
              )}
              <div className="row g-3">

                <div className="col-md-6">
                  <label>Tipo de documento</label>
                  <select
                    className="form-select"
                    value={newDocumentType}
                    onChange={(e) => setNewDocumentType(e.target.value)}
                  >
                    <option value="" hidden>Seleccione</option>
                    <option value="Contraloria">Contraloria</option>
                    <option value="Procuraduria">Procuraduria</option>
                    <option value="Policia">Policia</option>
                    <option value="Documento de identidad">Documento de identidad</option>
                    <option value="RUT">Rut</option>
                    <option value="Redam">Redam</option>
                  </select>
                </div>

                <div className="col-md-6">
                  <label>Documento (Subir archivo*)</label>
                  <input
                    type="file"
                    className="form-control"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={(e) => setNewDocumentFile(e.target.files[0])}
                  />
                </div>

              </div>
            </div>

            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => setShowDocumentModal(false)}
              >
                Cancelar
              </button>

            <button
              className="btn btn-outline-pink"
              onClick={handleSaveDocument}
            >
              Guardar
            </button>

            </div>
          </div>
        </div>
      </div>
      )}



    </div>
  );
};

export default MyCurriculum;
